/**
 * Banner — full-screen victory/defeat overlay. Click anywhere to restart
 * the skirmish (page reload).
 */
export class Banner {
  private el: HTMLDivElement;
  private shown = false;
  private shownVictory = false;

  constructor() {
    this.el = document.createElement("div");
    this.el.style.cssText =
      "position:fixed;inset:0;display:none;align-items:center;justify-content:center;" +
      "background:rgba(5,5,8,0.72);z-index:50;cursor:pointer;text-align:center;";
    this.el.addEventListener("click", () => window.location.reload());
    document.body.appendChild(this.el);
  }

  show(victory: boolean, subtitle: string): void {
    if (this.shown) return;
    this.shown = true;
    this.shownVictory = victory;
    const title = victory ? "VICTORY" : "DEFEAT";
    const color = victory ? "#b98b3a" : "#8c2b23";
    this.el.innerHTML =
      `<div><div style="font-size:64px;font-weight:bold;color:${color};` +
      `letter-spacing:12px;">${title}</div>` +
      `<div style="color:#e8e2d4;margin-top:12px;font-size:16px;">${subtitle}</div>` +
      `<div style="color:#9a917f;margin-top:8px;font-size:13px;">Click anywhere to play again</div></div>`;
    this.el.style.display = "flex";
  }

  get visible(): boolean {
    return this.shown;
  }

  /** Whether the shown banner is a victory (false = defeat). */
  get victory(): boolean {
    return this.shownVictory;
  }

  /** Dismiss the overlay (e.g. after loading a save). */
  hide(): void {
    this.shown = false;
    this.el.style.display = "none";
  }
}
